import React, { memo } from 'react';
import { Stack, Text, Flex, Box } from '@chakra-ui/react';

import { AlertsAndFollowUpQuestion } from '@/types/AnalysisResult';
import FollowUpItemBox from './FollowUpItemBox';

interface FollowUpItemsSectionProps {
  followUpQuestions: AlertsAndFollowUpQuestion[];
  onUpdateItem: (index: number, item: AlertsAndFollowUpQuestion | null) => Promise<boolean>;
  followUpItemsRef: React.RefObject<HTMLDivElement | null>;
}

const FollowUpItemsSection = memo(
  ({ followUpQuestions, onUpdateItem, followUpItemsRef }: FollowUpItemsSectionProps) => {
    return (
      <Stack ref={followUpItemsRef} id="follow-up-items-section">
        <Text color="neutrals.900" fontSize="18px" fontWeight="semibold" mb="8px">
          Follow-up Items
        </Text>
        <Text fontSize="16px" color="neutrals.700" mb="24px">
          This section highlights areas requiring clarification or action to better evaluate the
          candidate's fit for the role, focusing on gaps or ambiguities identified during the
          initial review.
        </Text>
        <Flex gap="20px" flexWrap="wrap">
          {followUpQuestions.map((item, index) => (
            <Box key={index} w="48%">
              <FollowUpItemBox
                followUpItem={item}
                onUpdateItem={onUpdateItem}
                index={index}
                readonly
                evaluate
                withStatus
                withFeedback
              />
            </Box>
          ))}
        </Flex>
      </Stack>
    );
  }
);

FollowUpItemsSection.displayName = 'FollowUpItemsSection';

export default FollowUpItemsSection;
